import type { WorkspaceAppManifest } from './workspaceManifest';

export const APP_MANIFEST = {
    appId: 'fbr-smart',
    permissionsPrefix: 'fbr',
    displayName: 'FBR Smart',

    navSections: [
        { key: 'dashboard', label: 'Dashboard', route: '/fbr/dashboard' },
        { key: 'sales',     label: 'Sales',     route: '/fbr/sales' },
        { key: 'customers', label: 'Customers', route: '/fbr/customers' },
        { key: 'catalog',   label: 'Catalog',   route: '/fbr/catalog' },
    ],

    resources: [
        {
            key: 'fbrInvoices',
            label: 'FBR Invoices',
            navSection: 'sales',
            recordRuleFields: [
                { field: 'CompanyId', operators: ['eq'] },
                { field: 'Status', operators: ['eq', 'neq', 'in', 'notin'] },
            ],
        },
        {
            key: 'customers',
            label: 'Customers',
            navSection: 'customers',
            recordRuleFields: [
                { field: 'CompanyId', operators: ['eq'] },
                { field: 'IsActive', operators: ['eq'] },
            ],
        },
        { key: 'products',        label: 'Products',        navSection: 'catalog' },
        { key: 'productProfiles', label: 'Product profiles', navSection: 'catalog' },
        { key: 'fbrScenarios',    label: 'FBR scenarios',   navSection: 'catalog' },
        { key: 'fbrSalesTaxRates',label: 'Sales tax rates', navSection: 'catalog' },
        { key: 'companies',       label: 'Companies',        navSection: 'catalog' },
        { key: 'categories',      label: 'Categories',       navSection: 'catalog' },
        { key: 'reviews',         label: 'Reviews',          navSection: 'catalog' },
    ],
} satisfies WorkspaceAppManifest;
